interface IsLegacyProps {
  componentName: string;
  channel: string;
}

export type Channels = 'BGH' | 'BNO' | 'BAS' | 'BYS' | 'GOS' | 'GOP' | 'PP' | 'VVX' | 'HMY';
type Whitelist = Record<string, Channels[]>;

const whitelist = {
  ProductPage: ['BGH', 'BNO', 'BAS', 'BYS', 'GOS', 'GOP', 'PP', 'VVX', 'HMY'],
  ProductlistPage: ['BGH', 'BNO', 'BAS', 'BYS', 'GOS', 'GOP', 'PP', 'VVX', 'HMY'],
  PpiPage: ['BGH', 'BNO', 'BAS', 'BYS', 'GOS', 'GOP', 'PP', 'VVX', 'HMY'],
  SearchProductlistPage: ['BGH', 'BNO', 'BAS', 'BYS', 'GOS', 'GOP', 'PP', 'VVX', 'HMY'],
  EditorialPage: ['BGH', 'BNO', 'GOP'],
  ContentPage: ['BGH', 'BNO', 'BYS', 'BAS', 'GOS', 'GOP', 'PP', 'VVX', 'HMY'],
  FavouritesPage: ['BGH', 'BNO', 'BYS', 'BAS', 'GOS', 'GOP', 'PP', 'VVX', 'HMY'],
  InstallationPage: ['BGH', 'BNO', 'BYS', 'BAS', 'GOS', 'GOP', 'PP'],
  SurveyVotePage: ['BGH', 'BNO', 'BYS', 'BAS', 'GOS', 'GOP', 'PP', 'VVX', 'HMY'],
  CustomerPage: ['BGH', 'BNO', 'BYS', 'BAS', 'GOS', 'PP', 'GOP', 'VVX', 'HMY'],
  KnowledgebasePage: ['PP'],
  CheckoutPage: ['BGH', 'BNO', 'BYS', 'BAS', 'GOS', 'GOP', 'PP', 'VVX', 'HMY'],
  HelpCenterPage: ['BGH', 'BYS', 'BAS', 'GOS', 'VVX', 'HMY']
} satisfies Whitelist;

export const isLegacy = ({ componentName, channel }: IsLegacyProps): boolean => {
  const name = componentName as keyof typeof whitelist;
  const channels = whitelist[name] || [];
  const isLegacy = !channels.find(_channel => _channel === channel);
  return isLegacy;
};
